import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutGrid, ChevronRight, Bell, Layers, ShieldAlert, Users, ArrowUpCircle, Rocket } from 'lucide-react';

const AppControl = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: 'Category Management',
      description: 'Manage app categories, banners, and icons',
      icon: LayoutGrid,
      route: '/app-control/category'
    },
    {
      title: 'App Service Group',
      description: 'Select which service group the app uses to display services',
      icon: Layers,
      route: '/app-control/service-group'
    },
    {
      title: 'Push Notifications',
      description: 'Send and manage push notifications to app users',
      icon: Bell,
      route: '/app-control/notifications'
    },
    {
      title: 'Maintenance Mode',
      description: 'Enable or disable app maintenance mode',
      icon: ShieldAlert,
      route: '/app-control/maintenance'
    },
    {
      title: 'Live Users',
      description: 'See who is currently using the app in real-time',
      icon: Users,
      route: '/app-control/live-users'
    },
    {
      title: 'Version Control',
      description: 'Manage app releases and force users to update',
      icon: ArrowUpCircle,
      route: '/app-control/versions'
    },
    {
      title: 'OTA Updates',
      description: 'Publish over-the-air JS bundle updates to client app',
      icon: Rocket,
      route: '/app-control/ota'
    }
  ];

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">App Control</h1>
        <p className="text-sm text-gray-500 mt-1">Manage the mobile application settings and content</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sections.map((section) => (
          <div
            key={section.title}
            onClick={() => navigate(section.route)}
            className="bg-white rounded-lg shadow border border-gray-100 p-5 cursor-pointer hover:shadow-md transition-shadow group"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-gray-100 rounded-lg">
                  <section.icon className="w-5 h-5 text-gray-700" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">{section.title}</h3>
                  <p className="text-xs text-gray-500 mt-0.5">{section.description}</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-gray-700 transition-colors" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppControl;
